import styled from 'styled-components';
import PropTypes from 'prop-types';
import defaultPicture from 'assets/images/user.png';
import MediaImage from '../MediaImage';

const sizes = {
  smallest: '23px',
  small: '35px',
  medium: '53px',
  large: '105px',
};

const baseURL = `${process.env.REACT_APP_API_URL}/api/rest`;

const ProfilePicture = styled(MediaImage).attrs(props => ({
  placeholderSrc: defaultPicture,
  width: sizes[props.size],
  height: sizes[props.size],
  src: props.mediaId ? `${baseURL}/contacts/${props.contactId}/image?jwt=${props.token}&id=${props.mediaId}` : null,
}))`
  border-radius: 50%;
  object-fit: cover;
  width: ${props => sizes[props.size]};
  height: ${props => sizes[props.size]};
`;
ProfilePicture.propTypes = {
  size: PropTypes.oneOf(['smallest', 'small', 'medium', 'large']),
  contactId: PropTypes.number,
  mediaId: PropTypes.number,
  token: PropTypes.string,
};
ProfilePicture.defaultProps = {
  size: 'small',
  contactId: null,
  mediaId: null,
};

export default ProfilePicture;
